// extracted by mini-css-extract-plugin
export default {"mark_default":"markDeafaultLocationButton_mark_default__HbQGx"};